import ImgBanner from "@/assets/image/video-bg.png";
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png";
import OurImg from "@/assets/industry-co-led/banner/our-offering.png";
import MsuAdvantagesImg from "@/assets/industry-co-led/banner/MSU-advantages.png";
import addintionImg from '@/assets/industry-co-led/image/little-girl-checking-up-her-sight-ophthalmology-center.png';


import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Img1 from "@/assets/industry-co-led/image/infrastructure-1.png";
import Img2 from "@/assets/industry-co-led/image/infrastructure-2.png";
import Img3 from "@/assets/industry-co-led/image/infrastructure-3.png";
import Img4 from "@/assets/industry-co-led/image/infrastructure-4.png";
import Img5 from "@/assets/industry-co-led/image/infrastructure-5.png";

import OJLImg1 from "@/assets/industry-co-led/image/OJL-1.png";
import OJLImg2 from "@/assets/industry-co-led/image/OJL-2.png";
import OJLImg3 from "@/assets/industry-co-led/image/OJL-3.png";
import OJLImg4 from "@/assets/industry-co-led/image/OJL-4.png";
import OJLImg5 from "@/assets/industry-co-led/image/OJL-5.png";
import OJLImg6 from "@/assets/industry-co-led/image/OJL-6.png";

export const masterAdvCareParam = {
    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led PG Programmes", url: "/industry-co-led-pg-programmes" },
            { name: "Master of Advanced Care Paramedic", url: "" },
        ],
        bannerImg: '/assets/industry-co-led-banner.png',
        title: "Master of Advanced Care Paramedic",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: REDVERSITY
        },
        duration: "2 Year PG Degree Programme",
        description:
            "Learn advanced pharmacology, critical care, trauma, obstetric and pediatric emergencies, disaster response, research methods and more.",

        stats: [
            {
                value: "Up to 70%",      // UPDATED: was "70%"
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        buttons: {
            // download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: "https://img.youtube.com/vi/zcCjUwVsjbY/hqdefault.jpg",
            thumbnailLocal: ImgBanner,
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/zcCjUwVsjbY?si=JZ_YozOfqtvNNrWz"

        },

        awards: [
            "Ranked 4th among Top Skill Universities in India by Outlook",
            "Emerging University of the Year by Financial Express",
            "Best University in India for Industry Interface by CEGR"
        ]
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",

        title: "Postgraduate Programme for Advanced Care Professionals",   // UPDATED

        description: [
            "The Master of Advanced Care Paramedic is a specialised postgraduate programme designed to build advanced clinical knowledge and expert-level competence in emergency and critical care. The curriculum integrates pre-hospital care, pharmacology, toxicology, trauma response, obstetric and pediatric emergencies and advanced medical management.",

            "Through high-fidelity simulations, supervised clinical rotations and a structured research dissertation, learners develop strong analytical ability, rapid decision-making skills and professional autonomy. Built to match evolving global EMT standards, the programme prepares paramedics to lead resuscitation, manage complex cases and coordinate within multidisciplinary emergency teams. Graduates emerge industry-ready for roles in advanced life support services, critical care transport, disaster management systems and hospital emergency departments, equipped to deliver safe, evidence-based, life-saving care."
        ],

        stats: [
            {
                value: "Up to 70%",      // UPDATED: was "70%"
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-Job Learning (OJL)"
            },
            {
                value: "100%",
                label: "Job-Linked Programmes"
            }
        ],

        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],

        journeyTitle: "Your 2-Year Journey",

        journey: [
            {
                phase: "YEAR 1",
                title: "Pre-Hospital Care & Clinical Foundations",
                description:
                    "Pre-Hospital Care Management, Pharmacology & Toxicology, Musculoskeletal & Surgical Emergencies, Research Methodology"
            },
            {
                phase: "YEAR 2",
                title: "Advanced Critical & Specialized Care",
                description:
                    "Critical Care Management, Obstetric & Pediatric Emergencies, Advanced Medical & Surgical Emergencies, Disaster Management"
            },
            {
                phase: "POST GRADUATE",
                title: "Master of Advanced Care Paramedic",
                description:
                    "Industry-ready advanced care paramedic professional with dissertation"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",

        title: {
            first: "Comprehensive",
            highlight: "Postgraduate Paramedic Education"
        },

        description:
            "We offer a UGC-approved, 2-year full-time postgraduate degree of Master of Advanced Care Paramedic at Medhavi Skills University, Sikkim. It is an industry-aligned healthcare degree designed to build strong paramedical skills and prepare students for diverse roles.",

        learningBox: {
            title: "Key Areas of Learning",

            points: [
                "Pre-Hospital Care Management",
                "Pharmacology & Toxicology",
                "Critical Care Management",
                "Obstetric & Pediatric Emergencies",
                "Advanced Medical & Surgical Emergencies",
                "Emergency Clinical Procedures",
                "Extensive Clinical Rotations & Dissertation"
            ]
        },

        image: 'https://cdn.msu.edu.in/msu-reavamp/indrustry-co-led/DSC00424.JPG',
    },

    whyEMT: {
        tag: "WHY EMERGENCY MEDICAL TECHNOLOGY. WHY NOW.",     // UPDATED
        title: "Answering India's Urgent Need for Skilled Paramedics",     // UPDATED
        description:
            "The Master of Advanced Care Paramedic programme aligns with these industry trends, offering a curriculum that integrates theory with hands-on training to prepare future-ready healthcare professionals.",

        stats: [
            {
                value: "US$ 638 Billion",
                text: "India's healthcare sector is expected to reach US$ 638 billion by 2025 (IBEF), creating massive demand for advanced paramedic professionals.",
            },
            {
                value: "2–3×",
                text: "2–3× more EMTs are required in India than currently available to meet WHO emergency response benchmarks",    // UPDATED
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Redversity, Delivered at MSU Campus",     // UPDATED
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",

        cards: [
            {
                number: "01",
                text: "Only University in Sikkim aligned with paid On-the-Job-Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only University in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped simulation labs, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme",

        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",       // UPDATED: was "70% practical based curriculum"
            "Paid on-the-job learning",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasonal medical professionals",    // UPDATED: was "Learn from seasoned healthcare professionals"
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives",
        ],

        image: 'https://cdn.msu.edu.in/msu-reavamp/indrustry-co-led/DSC00655+(1).JPG',
    },

    CTA: {
        title: "Lead the Frontlines of Emergency Care with Redversity's",
        highlights: " Master of Advanced Care Paramedic",
        url: "https://application.msu.edu.in/campus-programme-registration",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "Hands-On Experience",
        title: "On-The-Job Learning",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            {
                "id": 1,
                "src": "https://cdn.msu.edu.in/medium_Kabita_b5ccaaab65.webp",
                "srcLocal": OJLImg1,
                "alt": "Kabita Karki for On-the-Job Learning at Prashanti Diagnostic, Signtam",
                "caption": "Kabita Karki for On-the-Job Learning at Prashanti Diagnostic, Signtam"
            },
            {
                "id": 2,
                "src": "https://cdn.msu.edu.in/medium_MAMTA_35769bc27b.webp",
                "srcLocal": OJLImg2,
                "alt": "Mamta Khati for On-the-Job Learning at STNM, Gangtok",
                "caption": "Mamta Khati for On-the-Job Learning at STNM, Gangtok"
            },
            {
                "id": 3,
                "src": "https://cdn.msu.edu.in/medium_Subba_85c9905aca.webp",
                "srcLocal": OJLImg3,
                "alt": "Sancha rani Subba for On-the-Job Learning at Anukul Diagnostic, Namchi",
                "caption": "Sancha rani Subba for On-the-Job Learning at Anukul Diagnostic, Namchi"
            },
            {
                "id": 4,
                "src": "https://cdn.msu.edu.in/medium_Lalita_169d2968af.webp",
                "srcLocal": OJLImg4,
                "alt": "Lalita Pradhan for On-the-Job Learning at STNM, Gangtok",
                "caption": "Lalita Pradhan for On-the-Job Learning at STNM, Gangtok"
            },
            {
                "id": 5,
                "src": "https://cdn.msu.edu.in/medium_deepansa_9caf57d963.webp",
                "srcLocal": OJLImg5,
                "alt": "Deepansa for On-the-Job Learning at Magnus Hospital, Siliguri",
                "caption": "Deepansa for On-the-Job Learning at Magnus Hospital, Siliguri"
            },
            {
                "id": 6,
                "src": "https://cdn.msu.edu.in/medium_Bishnu_d768147532.webp",
                "srcLocal": OJLImg6,
                "alt": "Bishnu Maya Gurung for On-the-Job Learning at Siliguri Hospital",
                "caption": "Bishnu Maya Gurung for On-the-Job Learning at Siliguri Hospital"
            }
        ]
    },

    addtionSkill: {
        "courseSections": {
            "AdditionalSkills": {
                "tag": "Bonus Credentials",
                "title": "Additional Skills Certifications",
                "description": "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like Basic Life Support (BLS), Advanced Cardiovascular Life Support (ACLS), Basic Trauma Life Support (BTLS) and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
                "image": {
                    "url": "https://cdn.msu.edu.in/small_DSC_00373_1_532a10af8b.jpg",
                    "urlLocal": addintionImg,
                    "alternativeText": "Additional skills certifications image"
                },
                "items": [
                    {
                        "id": 1,
                        "text": "BLS, ACLS & BTLS Certified",
                        "icon": Icon1
                    },
                    {
                        "id": 2,
                        "text": "Nationally & Globally Recognised",
                        "icon": Icon2
                    }
                ],
                "button": {
                    "text": "Apply Now",
                    "link": "https://application.msu.edu.in/campus-programme-registration"
                }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description:
            "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms, and industry-relevant facilities",

        images: [
            {
                id: 1,
                src: "https://cdn.msu.edu.in/EMT_9cdd1dfe2e.webp",
                srcLocal: Img1,
                size: "large",
                alt: "Pathology Lab",
                caption: "Pathology Lab"
            },
            {
                id: 2,
                src: "https://cdn.msu.edu.in/EMT_4_3d66f2cd55.png",
                srcLocal: Img2,
                size: "large",
                alt: "Microbiology Lab",
                caption: "Microbiology Lab"
            },
            {
                id: 3,
                src: "https://cdn.msu.edu.in/b_sc_in_emergency_medical_technology_65089a01f5.webp",
                srcLocal: Img3,
                size: "small",
                alt: "Biotechnology Lab",
                caption: "Biotechnology Lab"
            },
            {
                id: 4,
                src: "https://cdn.msu.edu.in/art_1_ed655481a8.webp",
                srcLocal: Img4,
                size: "small",
                alt: "Classrooms",
                caption: "Classrooms"
            },
            {
                id: 5,
                src: "https://cdn.msu.edu.in/emergency_medical_technology_5a1a2eb660.webp",
                srcLocal: Img5,
                size: "small",
                alt: "Experience a Virtual Campus Tour",
                caption: "Experience a Virtual Campus Tour",
                videoId: "lTWke3-IGz4"
            },
        ],
    },

    medhaviBuzz: {
        tag: "MEDHAVI BUZZ",
        title: "Medhavi Buzz",
        images: [
            {
                id: 1,
                src: "https://cdn.msu.edu.in/medium_Health_camp_at_Jalipool_Old_Age_Home_Gangtok_East_Sikkim_1773a36ae9.jpg",
                alt: "Health camp at Jalipool Old Age Home, Gangtok, East Sikkim",
                caption: "Health camp at Jalipool Old Age Home, Gangtok, East Sikkim"
            },
            {
                id: 2,
                src: "https://cdn.msu.edu.in/medium_Health_Camp_at_Primary_School_Rangpo_Division_e856f12b40.jpg",
                alt: "Health Camp at Primary School, Rangpo Division",
                caption: "Health Camp at Primary School, Rangpo Division"
            },
            {
                id: 3,
                src: "https://cdn.msu.edu.in/medium_Promoting_Health_and_Hygiene_among_the_Sirwani_Community_5c0cef1a74.jpg",
                alt: "Promoting Health & Hygiene among the Sirwani Community",
                caption: "Promoting Health & Hygiene among the Sirwani Community"
            },
            {
                id: 4,
                src: "https://cdn.msu.edu.in/medium_First_ID_and_CPR_hands_on_training_at_Mangzing_Secondary_School_9d4e6c3e4d.jpg",
                alt: "First Aid and CPR hands-on training at Mangzing Secondary School",
                caption: "First Aid and CPR hands-on training at Mangzing Secondary School"
            },
            {
                id: 5,
                src: "https://cdn.msu.edu.in/medium_BLS_and_Posture_Awareness_at_Kumari_Pema_57b51270b6.jpg",
                alt: "Workshops on Basic Life Support (BLS) and Posture Awareness at Kumari Pema",
                caption: "Workshops on Basic Life Support (BLS) and Posture Awareness at Kumari Pema"
            }
        ]
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",    // UPDATED
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Eligibility",
        description:
            "B.Sc. in Critical Care Technology / Anesthesia & Critical Care Technology Bachelor in Emergency Medical Technology",
        button: {
            text: 'Apply Now',
            url: ""
        },
        items: [
            {
                title: "B.Sc. in Critical Care Technology",
                text: "Graduates with a B.Sc. in Critical Care Technology are eligible to apply for this Master's programme.",
            },
            {
                title: "Anesthesia & Critical Care Technology",
                text: "Graduates with a degree in Anesthesia & Critical Care Technology are eligible to apply.",
            },
            {
                title: "Bachelor of Emergency Medical Technology",
                text: "Graduates with a Bachelor of Emergency Medical Technology (Paramedic) degree are eligible to apply.",
            },
        ],
    },

    industryPartners: {
        tag: "INDUSTRY PARTNERS",
        title: "Our Industry Partners",
        description: "We collaborate with leading organisations across sectors to support practical learning, industry exposure, and career readiness for our students",
        partners: [
            {
                id: 1,
                src: "https://cdn.msu.edu.in/critical_care_hospital_08e305dc71.jpg",
                alt: "Critical Care Hospital"
            },
            {
                id: 2,
                src: "https://cdn.msu.edu.in/Medicity_Guwahati_8430e2f631.png",
                alt: "Medicity Guwahati"
            },
            {
                id: 3,
                src: "https://cdn.msu.edu.in/SGLH_4ae8656988.png",
                alt: "SGLH"
            },
            {
                id: 4,
                src: "https://cdn.msu.edu.in/Nephroplus_LOGO_8ec7ba2add.png",
                alt: "Nephroplus"
            },
            {
                id: 5,
                src: "https://cdn.msu.edu.in/small_pratiksha_hospital_Guwahati_logo_cdb1cd5a48.png",
                alt: "Pratiksha Hospital Guwahati"
            },
            {
                id: 6,
                src: "https://cdn.msu.edu.in/small_Apollo_Hospitals_Logo_svg_f94431f4a8.png",
                alt: "Apollo Hospitals"
            },
            {
                id: 7,
                src: "https://cdn.msu.edu.in/small_Siliguri_District_Hospital_Logo_7ef973e68b.png",
                alt: "Siliguri District Hospital"
            },
            {
                id: 8,
                src: "https://cdn.msu.edu.in/small_mukherjee_hospital_05f6e8e76e.png",
                alt: "Mukherjee Hospital"
            }
        ]
    },

    careerProspects: {
        "tag": "CAREER PROSPECTS",
        "heading": "Career Prospects",
        "description": "Join this course and embark on a rewarding journey in the heart of the healthcare sector",
        "roles": [
            "Advanced Care Paramedic (ACP)",
            "Critical Care Paramedic",
            "Flight/Air Ambulance Paramedic",
            "Emergency Department Specialist",
            "ICU/Critical Care Paramedic",
            "Trauma Response Specialist",
            "Disaster & Emergency Management Officer",
            "Industrial/Offshore Paramedic",
            "Emergency Medical Services (EMS) Supervisor",
            "Clinical Instructor/Paramedic Educator",
            "Pre-Hospital Care Coordinator",
            "Community Paramedicine Specialist",
            "Emergency Operations Manager",
            "Research Associate in Emergency & Trauma Care"
        ]
    },

    curriculumStructure: {
        "label": "What You Will Learn",
        "heading": "Curriculum Structure",
        "description": "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness, and broad career opportunities across disciplines.",
        "semesters": [
            {
                "name": "Semester 1",
                "title": "Foundations of Advanced Pre-Hospital Care",
                "description": "This semester builds advanced capabilities in pre-hospital systems, stabilization and clinical reasoning. Learners refine paramedic roles in communication, transport decisions and inter-professional teamwork while strengthening musculoskeletal and surgical emergency management. Research methodology introduces evidence-based thinking that supports future academic and clinical leadership. Structured clinical exposure begins to align classroom knowledge with real-time emergency care delivery.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Pre-Hospital Care Management",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Musculoskeletal Emergencies",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Surgical Emergencies",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Research Methodology and Biostatistics",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Clinical Rotation 1",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "HDSIM-PG 1: Leadership, Curricular Activities, Live Project I",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    }
                ],
                "learningOutcomes": [
                    "Lead organized pre-hospital responses",
                    "Stabilize trauma and surgical patients",
                    "Integrate research into decision-making",
                    "Improve documentation and communication",
                    "Apply learning in supervised settings"
                ]
            },
            {
                "name": "Semester 2",
                "title": "Critical & Toxicological Care",
                "description": "The focus shifts to intensive patient monitoring, pharmacological interventions and management of critically ill individuals. Learners develop mastery over drug calculations, ventilatory support and multi-organ emergencies. The semester enhances analytical ability, rapid prioritization and safe medication practices, supported by continued clinical immersion and elective exposure.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Pharmacology",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Critical Care Management",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Toxicology",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Open Elective",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Clinical Rotation 2",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "HDSIM-PG 2: CV Building, Industry Visits, Live Project II",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    }
                ],
                "learningOutcomes": [
                    "Administer medications safely in emergencies",
                    "Manage toxicological and poisoning cases",
                    "Perform advanced cardiovascular life support",
                    "Execute advanced airway techniques",
                    "Coordinate complex emergency interventions"
                ]
            },
            {
                "name": "Semester 3",
                "title": "Advanced Emergency Specialities",
                "description": "This semester deepens clinical capability in managing high-risk populations and complex presentations. Learners strengthen rapid assessment, intervention planning and multidisciplinary coordination. Special focus areas include maternal, neonatal and pediatric emergencies alongside advanced adult medical crises, supported by hands-on training in dynamic healthcare environments.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Obstetric and Gynaecological Emergencies",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Paediatric Emergencies",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "Medical Emergencies – I",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Open Elective",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Clinical Rotation 3",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "HDSIM-PG 3: Personality Dev, Ambulance Ride-along (Advanced), Live Project III",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    }
                ],
                "learningOutcomes": [
                    "Manage critical care patients during transport",
                    "Handle obstetric emergencies confidently",
                    "Assess and stabilize pediatric patients",
                    "Perform neonatal resuscitation",
                    "Coordinate critical care handovers"
                ]
            },
            {
                "name": "Semester 4",
                "title": "Advanced Practice, Disaster & Research",
                "description": "The final semester prepares learners for autonomous specialist practice. Emphasis is placed on complex procedures, disaster and industrial emergency systems and higher-order medical management. A structured dissertation develops research, academic writing and analytical expertise, while rotations consolidate readiness for leadership roles.",
                "keySubjectsLabel": "Key Subjects",
                "subjects": [
                    {
                        "name": "Emergency Clinical Procedure",
                        "bgColor": "bg-[#C8E6FF]",
                        "textColor": "text-[#0475B3]"
                    },
                    {
                        "name": "Disaster Management and Industrial Emergency",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    },
                    {
                        "name": "Advanced Medical Emergencies – II",
                        "bgColor": "bg-[#D4F4DD]",
                        "textColor": "text-[#006B3D]"
                    },
                    {
                        "name": "Dissertation",
                        "bgColor": "bg-[#E8D4FF]",
                        "textColor": "text-[#7B2CBF]"
                    },
                    {
                        "name": "Clinical Rotation 4",
                        "bgColor": "bg-[#FFD4E5]",
                        "textColor": "text-[#C41E3A]"
                    },
                    {
                        "name": "HDSIM-PG 4: Career Launch, Viva Intensive, Live Project Capstone",
                        "bgColor": "bg-[#FFE5CC]",
                        "textColor": "text-[#CC6600]"
                    }
                ],
                "learningOutcomes": [
                    "Lead disaster and mass casualty responses",
                    "Manage complex medical and surgical emergencies",
                    "Execute advanced clinical procedures autonomously",
                    "Present evidence-based research findings",
                    "Operate as an advanced paramedic leader"
                ]
            },
            {
                "name": "Value Addition",
                "title": "Value-Added Learning Opportunities",
                "description": "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                "keySubjectsLabel": "Key Features",

                "subjects": [
                    { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
                    { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
                    { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
                    { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
                ],
                "learningOutcomes": [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]

    },

    faq: {
        id: 102,
        title: "Master of Advanced Care Paramedic",
        FAQ: [
            {
                "id": 1,
                "Question": "What does this Master of Advanced Care Paramedic Technology programme cover?",
                "Answer": "The Master of Advanced Care Paramedic covers advanced pharmacology, toxicology, critical care management, pre-hospital care, obstetric and pediatric emergencies, trauma response, disaster management, research methodology and extensive clinical rotations culminating in a dissertation."
            },
            {
                "id": 2,
                "Question": "Is the curriculum NCAHP aligned?",
                "Answer": "Yes."
            },
            {
                "id": 3,
                "Question": "What is the duration of this programme?",
                "Answer": "The Master of Advanced Care Paramedic at MSU is a 2-year full-time postgraduate programme spread across 4 semesters, with up to 6 months of paid On-the-Job Learning embedded in the curriculum."
            },
            {
                "id": 4,
                "Question": "How is this programme different from a basic paramedic or EMT course?",
                "Answer": "This is a postgraduate-level degree that builds advanced clinical expertise, autonomous decision-making, research competency and leadership skills. Unlike basic EMT programmes, it covers critical care transport, advanced pharmacology, disaster management and includes a research dissertation."
            },
            {
                "id": 5,
                "Question": "What subjects are covered in this programme?",
                "Answer": "Key subjects include Pre-Hospital Care Management, Advanced Pharmacology & Toxicology, Critical Care Management, Obstetric & Pediatric Emergencies, Musculoskeletal & Surgical Emergencies, Disaster Management, Emergency Clinical Procedures, Research Methodology & Biostatistics, and Clinical Rotations."
            },
            {
                "id": 6,
                "Question": "What is the eligibility criteria to enroll in this Masters in Advanced Care Paramedic course?",
                "Answer": "Candidates must hold a B.Sc. in Critical Care Technology, Anesthesia & Critical Care Technology, or a Bachelor of Emergency Medical Technology (Paramedic) from a recognized university."
            },
            {
                "id": 7,
                "Question": "What is the scope of Advanced Care Paramedic in India?",
                "Answer": "India needs 2–3 times more EMTs than currently available to meet WHO emergency response benchmarks. With the healthcare sector projected to reach US$ 638 billion by 2025, there is significant and growing demand for advanced care paramedics across hospitals, air ambulances, critical care transport and disaster management."
            },
            {
                "id": 8,
                "Question": "Is Masters in Advanced Care Paramedic a good career option?",
                "Answer": "Yes, it is a promising career for those interested in emergency and critical care, offering opportunities to work in life-saving roles with growing demand in the healthcare sector."
            },
            {
                "id": 9,
                "Question": "What job roles can you expect after completing this programme?",
                "Answer": "Graduates can work as Advanced Care Paramedic (ACP), Critical Care Paramedic, Flight/Air Ambulance Paramedic, ICU/Critical Care Paramedic, Trauma Response Specialist, Disaster & Emergency Management Officer, EMS Supervisor, Clinical Instructor, Pre-Hospital Care Coordinator, Community Paramedicine Specialist, Emergency Operations Manager, and Research Associate in Emergency & Trauma Care."
            },
            {
                "id": 10,
                "Question": "Is this course UGC recognised?",
                "Answer": "Yes."      // UPDATED: was "Yes, the Master of Advanced Care Paramedic at Medhavi Skills University is UGC approved."
            },
            {
                "id": 11,
                "Question": "Can you enroll in this degree with a scholarship?",
                "Answer": "Yes. MSU is the only university in Sikkim to ensure 100% of student applicants receive government scholarships. Talk to our counselors to know more."
            },
            {
                "id": 12,
                "Question": "What is the admission procedure?",
                "Answer": "Call +91 98748 75876 for a detailed admission procedure. You can also refer to the link https://www.msu.edu.in/admission-process"
            }
        ]
    },

    programmeOverviewImage: {
        src: "https://cdn.msu.edu.in/MLT_Program_overview_2_01701b7fc7.jpg",
        alt: "Programme Overview"
    }
    , coursePrice: { price: "₹4,00,000" }

};